// extracted by mini-css-extract-plugin
export var addButton = "_67-d";
export var bullets = "_67-e";
export var compact = "_67-2";
export var container = "_67-j";
export var extendedWarrantyModal = "_67-f";
export var learn = "_67-l";
export var learnMore = "_67-g";
export var offeringOption = "_67-3";
export var offeringPrice = "_67-8";
export var offeringSubtitle = "_67-7";
export var offeringTitle = "_67-6";
export var offeringsContainer = "_67-0";
export var pdpTilesBackground = "_67-n";
export var plan = "_67-m";
export var regular = "_67-1";
export var remove = "_67-k";
export var seeDetailsIcon = "_67-i";
export var seeDetailsLink = "_67-h";
export var selectedOption = "_67-4";
export var shieldIcon = "_67-b";
export var shieldIconCompact = "_67-c";
export var subtitle = "_67-a";
export var title = "_67-9";
export var unselectedOption = "_67-5";